import Consultation from '~models/consultation'

export type ConcernLevelBlockProps = Pick<
  Consultation.Level2,
  'pet' | 'concern_lv' | 'concern_lv_expression' | 'concern_lv_description'
>

export enum Level {
  One = 1,
  Two,
  Three,
  Four,
  Five,
  Six,
  Seven,
  Eight,
  Nine,
  Ten,
}
